import React from 'react';
import './NavbarCloseButton.css';

interface NavbarCloseButtonProps {
  readonly onClose: () => void;
  readonly ariaLabel?: string;
}

/** Far-right close control for modal-style header bars. */
function NavbarCloseButton({
  onClose,
  ariaLabel = 'Close',
}: NavbarCloseButtonProps): React.ReactElement {
  return (
    <button
      type="button"
      className="navbar-close-btn"
      onClick={onClose}
      aria-label={ariaLabel}
    >
      ×
    </button>
  );
}

export default NavbarCloseButton;
